<template>
  <main class="mw7-ns center-ns">
    <br>
    <div v-if="emailError" class="f6 mb3 red tc">
      A user with this email already exists.
      Please verify your entry or
      <a class="color-theme underline dib" href="mailto:support@getakko.com">contact support</a>
    </div>
    <div v-else-if="phoneError" class="f6 mb3 red tc">
      A user with this phone number already exists.
      Please verify your entry or
      <a class="color-theme underline dib" href="mailto:support@getakko.com">contact support</a>
    </div>

    <div class="mb4 pt4">
      <label for="email" class="f6 b db mb2">Student's Email (use .edu address)*</label>
      <input id="email" class="input-reset ba b--black-20 pa2 mb2 db w-100 br1" type="email" v-model="email" autocomplete="email" @blur="checkEmail" @focus="email_unfocused = false" v-focus maxlength="50">
      <div class="f6 silver mt2">
        If you do not have a .edu email, enter an alternate email address. You will need to provide verification of student status.
      </div>
      <div v-show="email !== '' && (!email.includes('@') || !email.includes('.'))"
        class="red f7 mt2">
        Must use a valid email address
      </div>
    </div>

    <div v-show="!hasEduEmail">
        <div class="f5 db mb3">Student Verification</div>
        <label for="school" class="f6 b db mb2">School Name*</label>
        <input id="school" class="input-reset ba b--black-20 pa2 mb2 db w-100 br1" type="text" v-model="school" />
        <p>Please upload proof of your student status (school ID, unofficial transcript, receipt of tuition paid, or class schedule)</p>
        <div class="pv5 w-100 tc mb5" :class="image_file_name ? 'bg-washed-green' : 'bg-washed-red'">
          <input id="file" class="input-reset dn" type="file" @change="processImage($event)" accept="image/*, application/pdf,.heic,.heif,.HEIC,.HEIF" />
          <label for="file" class="dib fw5 pv2 ph5 br-pill pointer ba bw1  white "
            :class="image_file_name ? 'bg-green b-green' : 'bg-theme b-theme'">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" class="v-sub mr1" fill="white">
                <path d="M10 0l-5.2 4.9h3.3v5.1h3.8v-5.1h3.3l-5.2-4.9zm9.3 11.5l-3.2-2.1h-2l3.4 2.6h-3.5c-.1 0-.2.1-.2.1l-.8 2.3h-6l-.8-2.2c-.1-.1-.1-.2-.2-.2h-3.6l3.4-2.6h-2l-3.2 2.1c-.4.3-.7 1-.6 1.5l.6 3.1c.1.5.7.9 1.2.9h16.3c.6 0 1.1-.4 1.3-.9l.6-3.1c.1-.5-.2-1.2-.7-1.5z"/>
              </svg>
              <span class="white">{{image_file_name ? 'File Selected' : 'Upload Transcript/ID'}}</span>
          </label>
        </div>
      </div>

    <div class="mb4">
      <div>
        <label for="phone_no" class="f6 b db mb2">Phone number</label>
        <input id="phone_no"
          class="input-reset ba b--black-20 pa2 mb2 db w-100 br1"
          name="phone_no"
          type="tel"
          v-model="phone_no"
          @blur="setPhoneNo"
          maxlength="11"
        />
      </div>
      <div v-show="phone_unfocused && phone_no !== '' && !isValidPhone(phone_no)"
           class="red f7 mt2">
        Must use a valid phone number
      </div>
    </div>

    <div class="mb3" v-show="errorList.length > 0">
      <span class="red">Error submitting registration:</span>
      <span class="red" v-for="(e, index) in errorList" :key="index">{{e}}</span>
    </div>

    <div class="f5 db mb3">Payment Information</div>

    <div class="mt4 mb4 grid-half">
      <div>
        <label for="first_name" class="f6 b db mb2">Cardholder First Name</label>
        <input id="first_name"
          class="input-reset ba b--black-20 pa2 mb2 db w-100 br1"
          name="first_name"
          type="text"
          v-model="first_name" />
          <div v-if="registration.coverage.name.toLowerCase().includes('monthly')" class="f6 i mb4">
          <!--  Discount codes applied to monthly payment plans discount your payments for the first 4 months. -->
          </div>
      </div>
      <div>
        <label for="last_name" class="f6 b db mb2">Cardholder Last Name</label>
        <input id="last_name"
          class="input-reset ba b--black-20 pa2 mb2 db w-100 br1"
          name="last_name"
          type="text"
          v-model="last_name" />
      </div>
    </div>

    <div>
      <label for="card-element" class="f6 b db mb2">
        <span>Credit or Debit Card</span>
      </label>
      <div id="card-element">
        <!-- a Stripe Element will be inserted here. -->
      </div>

      <!-- Used to display form errors -->
      <div id="card-errors" role="alert" class="red f7 mt2"></div>

      <div class="f6 silver mv2">All major credit cards accepted</div>

      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="119px" height="26px">
        <path fill-rule="evenodd"  opacity="0.502" fill="rgb(66, 71, 112)"
        d="M113.000,26.000 L6.000,26.000 C2.686,26.000 0.000,23.314 0.000,20.000 L0.000,6.000 C0.000,2.686 2.686,-0.000 6.000,-0.000 L113.000,-0.000 C116.314,-0.000 119.000,2.686 119.000,6.000 L119.000,20.000 C119.000,23.314 116.314,26.000 113.000,26.000 ZM11.128,8.892 L8.571,8.892 L8.571,16.133 L9.918,16.133 L9.918,13.533 L11.128,13.533 C12.602,13.533 13.654,12.586 13.654,11.218 C13.654,9.850 12.602,8.892 11.128,8.892 ZM17.043,10.745 C15.454,10.745 14.328,11.881 14.328,13.502 C14.328,15.112 15.454,16.259 17.043,16.259 C18.632,16.259 19.748,15.112 19.748,13.502 C19.748,11.881 18.632,10.745 17.043,10.745 ZM26.936,10.871 L25.873,14.449 L24.810,10.871 L23.590,10.871 L22.527,14.449 L21.464,10.871 L20.117,10.871 L21.927,16.133 L23.137,16.133 L24.200,12.555 L25.274,16.133 L26.484,16.133 L28.283,10.871 L26.936,10.871 ZM31.252,10.745 C29.747,10.745 28.653,11.871 28.653,13.460 C28.653,15.101 29.768,16.259 31.357,16.259 C31.946,16.259 32.546,16.122 33.146,15.849 L33.146,14.722 C32.599,15.038 32.062,15.217 31.578,15.217 C30.694,15.217 30.063,14.670 29.978,13.870 L33.546,13.870 C33.567,13.691 33.567,13.523 33.567,13.375 C33.567,11.829 32.630,10.745 31.252,10.745 ZM37.724,10.797 C37.577,10.755 37.430,10.745 37.282,10.745 C36.830,10.745 36.367,10.976 35.988,11.397 L35.988,10.871 L34.641,10.871 L34.641,16.133 L35.988,16.133 L35.988,12.618 C36.335,12.176 36.809,11.934 37.251,11.934 C37.409,11.934 37.577,11.955 37.724,11.997 L37.724,10.797 ZM40.808,10.745 C39.303,10.745 38.209,11.871 38.209,13.460 C38.209,15.101 39.325,16.259 40.914,16.259 C41.503,16.259 42.103,16.122 42.703,15.849 L42.703,14.722 C42.155,15.038 41.619,15.217 41.134,15.217 C40.251,15.217 39.619,14.670 39.535,13.870 L43.102,13.870 C43.123,13.691 43.123,13.523 43.123,13.375 C43.123,11.829 42.187,10.745 40.808,10.745 ZM48.912,8.566 L47.554,8.566 L47.554,11.229 C47.144,10.913 46.681,10.745 46.218,10.745 C44.818,10.745 43.840,11.881 43.840,13.502 C43.840,15.122 44.818,16.259 46.218,16.259 C46.681,16.259 47.144,16.091 47.554,15.764 L47.554,16.133 L48.912,16.133 L48.912,8.566 ZM55.690,10.745 C55.238,10.745 54.775,10.913 54.354,11.229 L54.354,8.566 L53.007,8.566 L53.007,16.133 L54.354,16.133 L54.354,15.764 C54.775,16.091 55.238,16.259 55.690,16.259 C57.100,16.259 58.068,15.122 58.068,13.502 C58.068,11.881 57.100,10.745 55.690,10.745 ZM62.310,10.871 L61.037,14.323 L59.774,10.871 L58.395,10.871 L60.405,15.943 L59.395,18.437 L60.700,18.437 L63.689,10.871 L62.310,10.871 ZM73.109,10.288 C73.972,10.288 75.069,10.552 75.933,11.019 L75.933,8.344 C74.992,7.969 74.052,7.825 73.111,7.825 C70.808,7.825 69.273,9.028 69.273,11.038 C69.273,14.181 73.589,13.671 73.589,15.026 C73.589,15.551 73.133,15.721 72.500,15.721 C71.559,15.721 70.345,15.332 69.392,14.814 L69.392,17.525 C70.448,17.979 71.518,18.169 72.497,18.169 C74.858,18.169 76.485,17.003 76.485,14.959 C76.485,11.573 72.144,12.181 72.144,10.903 C72.144,10.460 72.514,10.288 73.109,10.288 ZM82.180,8.014 L80.024,8.014 L80.022,5.548 L77.250,6.138 L77.237,15.247 C77.237,16.928 78.502,18.169 80.187,18.169 C81.115,18.169 81.801,18.001 82.179,17.793 L82.179,15.482 C81.816,15.627 80.024,16.148 80.024,14.475 L80.024,10.435 L82.180,10.435 L82.180,8.014 ZM88.275,8.015 C87.897,7.879 86.570,7.631 85.905,8.853 L85.727,8.014 L83.272,8.014 L83.272,17.966 L86.110,17.966 L86.110,11.219 C86.781,10.338 87.914,10.508 88.275,10.625 L88.275,8.015 ZM91.999,4.230 L89.149,4.836 L89.149,7.149 L91.999,6.543 L91.999,4.230 ZM91.999,8.014 L89.149,8.014 L89.149,17.966 L91.999,17.966 L91.999,8.014 ZM98.125,7.825 C97.012,7.825 96.293,8.349 95.901,8.715 L95.753,8.014 L93.253,8.014 L93.254,21.268 L96.093,20.664 L96.099,17.451 C96.507,17.750 97.114,18.169 98.108,18.169 C100.139,18.169 101.997,16.535 101.997,12.927 C101.997,9.621 100.119,7.825 98.125,7.825 ZM107.049,7.825 C104.348,7.825 102.704,10.121 102.704,13.013 C102.704,16.437 104.642,18.169 107.408,18.169 C108.765,18.169 109.784,17.861 110.555,17.433 L110.555,15.146 C109.781,15.536 108.893,15.774 107.766,15.774 C106.659,15.774 105.684,15.382 105.557,14.051 L111.116,14.051 C111.129,13.898 111.154,13.303 111.154,13.028 C111.154,10.120 109.746,7.825 107.049,7.825 ZM107.031,10.140 C107.728,10.140 108.468,10.677 108.468,11.955 L105.532,11.955 C105.532,10.676 106.321,10.140 107.031,10.140 ZM97.446,15.661 C96.780,15.661 96.383,15.421 96.107,15.122 L96.090,10.903 C96.386,10.578 96.795,10.340 97.446,10.340 C98.485,10.340 99.200,11.504 99.200,12.989 C99.200,14.518 98.496,15.661 97.446,15.661 ZM55.406,15.101 C55.038,15.101 54.669,14.943 54.354,14.628 L54.354,12.376 C54.669,12.060 55.038,11.902 55.406,11.902 C56.164,11.902 56.690,12.555 56.690,13.502 C56.690,14.449 56.164,15.101 55.406,15.101 ZM46.513,15.101 C45.744,15.101 45.218,14.449 45.218,13.502 C45.218,12.555 45.744,11.902 46.513,11.902 C46.881,11.902 47.249,12.060 47.554,12.376 L47.554,14.628 C47.249,14.943 46.881,15.101 46.513,15.101 ZM40.756,11.786 C41.355,11.786 41.787,12.281 41.829,12.997 L39.535,12.997 C39.598,12.271 40.103,11.786 40.756,11.786 ZM31.199,11.786 C31.799,11.786 32.231,12.281 32.273,12.997 L29.978,12.997 C30.042,12.271 30.547,11.786 31.199,11.786 ZM17.043,15.133 C16.254,15.133 15.707,14.470 15.707,13.502 C15.707,12.534 16.254,11.871 17.043,11.871 C17.822,11.871 18.369,12.534 18.369,13.502 C18.369,14.470 17.822,15.133 17.043,15.133 ZM10.939,12.439 L9.918,12.439 L9.918,9.987 L10.939,9.987 C11.718,9.987 12.265,10.482 12.265,11.218 C12.265,11.944 11.718,12.439 10.939,12.439 Z"/>
      </svg>
    </div>

    <div class="mt4">
      <label for="promo_code" class="f6 b db mb2">
        Discount Code
        <span v-if="$store.state.registration.promo.status=='valid'" style="color: green;"> - VALID (${{(discount_in_months / 100)}} OFF)</span>
        <span v-else-if="$store.state.registration.promo.status=='invalid'" style="color: red;"> - INVALID</span>
      </label>
      <div class="input-group-flex mb2">
        <input id="promo_code"
          class="input-reset ba b--black-20 pa2 db w-100 br1 ttu"
          type="text"
          v-on:keyup.enter="checkPromoCode"
          v-model="promo_code" />
          <button class="f6 link dim ba bw2 ph3 pv2 dib dark-green submit-btn" @click="checkPromoCode">Submit</button>
      </div>
      <div v-if="coverage.name.toLowerCase().includes('monthly')" class="f6 i mb4">
      <!--  Discount codes applied to monthly payment plans discount your payments for the first 4 months. -->
      </div>
    </div>
    <br />
    <div class="mb2 f6">
      <div class="silver mb2">Checkout:</div>
      <div class="black lh-copy">AKKO Student Plan: ${{coverage.price}}</div>
      <div v-if="activation_fee" class="black lh-copy">Activation Fee (one-time): +${{$store.state.registration.activation_fee.value}}</div>
      <div v-if="discount" class="black lh-copy">
        Discount Code: -${{discount_in_months / 100}}
      </div>
      <div v-if="activation_fee || discount" class="black lh-copy mt3">Total: ${{cardCharge}} ({{ selectedCountryCurrency.currency_code }})</div>
    </div>

    <div class="mv3">
      <input id="accept" type="checkbox" class="di" v-model="accept">
      <label for="accept" class="f6 fw5 di mb2 lh-copy">
        I agree that I have thoroughly read, understand, and accept the
        <a href="https://getakko.com/legal" target="_blank" class="color-theme">terms of service &amp; conditions</a>
        as well as the <a href="https://getakko.com/coverage-info-faqs/" target="_blank" rel="noopener" class="color-theme">AKKO website's FAQs</a> about plan protection and claims.
        I also acknowledge and agree to receive and view all plan documentation, including Terms and Conditions and Plan Confirmation (if any), electronically as well as receive automated transactional messages via email and SMS in accordance with AKKO's Privacy Policy.
        <br>
        <br>
        <!-- You must complete activation in the following step and verify your email address. You must add your items to your account with their information and pictures according to all instructions
        for you to be eligible for reimbursements of losses. All plans are billed on a recurring annual or monthly basis until cancelled. -->
      </label>
    </div>

    <div class="mv4 flex justify-center">
      <ak-button class="flex-grow flex-grow-off-ns" :disabled="!stepComplete" green @click.native='submit'>
        Register
      </ak-button>
    </div>

    <div class="black f6 mv4 mw7-ns center tc lh-copy">
      Elite Risk Insurance Solutions Lic#0G40499. <!-- All coverage plans provided by NSSI and underwritten by
      <br />
      <a href="https://www.hanover.com/about-our-companies.html" target="_blank" rel="noopener noreferrer" class="black">
        Allmerica Financial Benefit Company a member of The Hanover Insurance Group, (est. 1852)
      </a> -->
    </div>

  </main>
</template>

<script>
import AkButton from '@/components/Button'
import {mapState} from 'vuex'

export default {
  name: 'ak-review',
  components: {
    AkButton
  },
  data () {
    return {
      email: '',
      email_unfocused: false,
      school: '',
      image_file: null,
      image_file_name: '',
      stripe: null,
      card: null,
      first_name: '',
      last_name: '',
      phone_no: '',
      phone_unfocused: false,
      stripe_token: '',
      accept: false,
      promo_code: '',
      monthlyPayment: false
    }
  },
  mounted () {
    // this.$intercom.boot({})
    window.fbq('trackCustom', 'Review and Submit')
    this.$store.commit('SET_ERRORS', null)
    this.initStripe()
    this.promo_code = this.$store.state.registration.promo.code
    this.$store.dispatch('getAllCoverageOptions')
    const coverageId = this.$store.state.registration.coverage.id
    var startCoverage = this.$store.state.coverageOptions.filter(el => el.id === coverageId)[0]
    this.monthlyPayment = !startCoverage.name.includes('Annual')
    this.$store.commit('RESET_REDEMPTION_ALL')
  },
  methods: {
    checkEmail () {
      this.$store.commit('SUBMIT_EMAIL', {email: this.email.trim()})
      this.$store.dispatch('checkEmailExists', {email: this.email.trim()})
      this.$store.dispatch('generateLead')
      this.email_unfocused = true
    },
    setPhoneNo () {
      this.$store.dispatch('checkPhoneExists', {phone: this.phone_no.trim()})
      this.$store.commit('SET_PHONE', {phone_no: this.phone_no.trim()})
      this.$store.dispatch('generateLead')
      this.phone_unfocused = true
    },
    processImage (event) {
      this.image_file = event.target.files[0]
      this.image_file_name = this.image_file.name
    },
    async submit () {
      window.fbq('trackCustom', 'Clicked Register')

      // Set the loading flag
      this.$store.commit('SET_LOADING', true)

      // First create the stripe token
      const result = await this.stripe.createToken(this.card)

      // Display errors or submit registration with the token
      if (result.error) {
        const errorElement = document.getElementById('card-errors')
        errorElement.textContent = result.error.message
        this.$store.commit('SET_LOADING', false)
      } else {
        this.stripe_token = result.token.id
        const payload = {
          'email': this.email,
          'phone_no': this.phone_no,
          'stripe_token': this.stripe_token,
          'card_first_name': this.first_name,
          'card_last_name': this.last_name,
          'school': this.school,
          'verification_file': this.image_file
        }
        this.$store.dispatch('submitRegistration', payload)
      }
    },
    initStripe () {
      // Get the right environment
      const debug = process.env.NODE_ENV !== 'production'

      // Get the right stripe key
      const stripePKey = debug ? 'pk_test_jTPxTNZwPNAYq0F6Nwu5mPkc' : 'pk_live_ne4lzjFFUgcbVDlPJwK2ZmKb'

      // Start stripe
      this.stripe = window.Stripe(stripePKey)
      // Create an instance of Elements
      const elements = this.stripe.elements()
      // Create an instance of the card Element
      this.card = elements.create('card')
      // Add an instance of the card Element into the `card-element` <div>
      this.card.mount('#card-element')

      // Handle real-time validation errors from the card Element.
      this.card.addEventListener('change', (event) => {
        const displayError = document.getElementById('card-errors')
        event.error ? displayError.textContent = event.error.message : displayError.textContent = ''
      })
    },
    checkPromoCode () {
      const payload = {
        promo_code: this.promo_code.toUpperCase()
      }
      this.$store.dispatch('checkPromo', payload)
    }
  },
  computed: {
    ...mapState({
      selectedCountryCurrency: state => state.registrationv2.selectedCountryCurrency
    }),
    emailError () {
      return this.$store.state.registration.email_error
    },
    phoneError () {
      return this.$store.state.registration.phone_error
    },
    hasEduEmail () {
      return !RegExp(/.+@.+\....+/).test(this.email) ||
      this.email.trim().endsWith('.edu')
    },
    stepComplete () {
      return this.accept &&
      this.first_name.trim !== '' &&
      this.last_name.trim !== '' &&
      this.email.trim() !== '' &&
      this.email.includes('@') &&
      this.email.includes('.') &&
      (this.hasEduEmail || (this.image_file && this.image_file_name)) &&
      this.phone_no.trim() !== '' &&
      this.isValidPhone(this.phone_no) &&
      !this.emailError
    },
    registration () {
      return this.$store.state.registration
    },
    coverage () {
      return this.$store.state.coverageOptions.filter((item) => item.id === this.registration.coverage.id)[0]
    },
    errorList () {
      return this.$store.state.errors
    },
    discount_in_months () {
      return this.$store.state.registration.promo.duration_in_months * this.$store.state.registration.promo.amount_off
    },
    discount () {
      return this.$store.state.registration.promo.amount_off
    },
    cardCharge () {
      const base = this.coverage.price
      const activationFee = this.activation_fee ? this.$store.state.registration.activation_fee.value : 0
      const discount = this.discount / 100
      console.log(this.discount / 100)
      return (base + activationFee - discount).toFixed(2)
    },
    activation_fee () {
      return this.registration.activation_fee.applies
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$intercom.shutdown()
    next()
  }
}
</script>

<style scoped>
.StripeElement {
  background-color: white;
  padding: 10px 12px;
  border-radius: .125rem;
  border: 1px solid rgba(0,0,0,.2);
}

.StripeElement--focus {
  border-color: #f3103c;
}

.StripeElement--invalid {
  border-color: #fa755a;
}

.StripeElement--webkit-autofill {
  background-color: #fefde5;
}

.input-group-flex {
  display: flex;
  align-items: stretch;
}

.text-field-flex {
  flex: 1;
}

.promo-submit-btn {
  flex: 1;
  cursor: pointer;
  border: 3px solid #137752;
  padding: 4px 12px;
  color: #137752;
  font-size: .9rem;
  font-weight: 800;
}
</style>



// WEBPACK FOOTER //
// ReviewAndSubmit.vue?7acb927e